import BluebirdPromise from 'bluebird';
import {
  navigateStart,
  navigateStop,
} from 'app/gamma/src/modules/state/ui/navigating';
import { defaultStore } from 'app/gamma/src/defaultStore';

export const getSpinner = () => {
  defaultStore.dispatch(navigateStart());
  return BluebirdPromise.resolve().disposer(function () {
    defaultStore.dispatch(navigateStop());
  });
};
